(function() {
    var accessoriesComponent = {
        selectors: {
            buyAccessoryButton: '[data-buy-accessory]',
            removeAccessoryButton: '[data-remove-accessory]',
            spinner: '[data-spinner]',
            ctaCopy: '[data-cta-copy]',
        },
        routes: {
            'buy': '/beta/ajax/add-to-basket',
            'remove': '/beta/ajax/remove-from-basket'
        },
        init: function() {
            $(document).on('click', accessoriesComponent.selectors.buyAccessoryButton, accessoriesComponent.addToBasket);
            $(document).on('click', accessoriesComponent.selectors.removeAccessoryButton, accessoriesComponent.removeFromBasket);
        },
        addToBasket: function(event) {
            event.preventDefault();
            var $element = $(event.currentTarget),
                elementDealId = $element.data('dealId'),
                elementGiftCode = $element.data('giftCode'),
                elementParentId = $element.data('parentId'),
                $elementInstances = $('[data-buy-accessory][data-deal-id="' + elementDealId + '"][data-parent-id="' + elementParentId + '"]'),
                activeSlideIndex = $element.closest('.swiper-wrapper').children('.swiper-slide-active').prevAll().length;
            $element.toggleClass('btn-gray-shade-2', true);
            $element.toggleClass('btn-erminto', false);
            $.ajax({
                type: 'POST',
                url: '/beta/ajax/add-to-basket',
                data: {
                    'dealId': elementDealId,
                    'giftCode': elementGiftCode,
                    'itemType': 'deal',
                    'parentId': elementParentId,
                },
                beforeSend: function() {
                    accessoriesComponent.setCallToActionComponents($elementInstances, true, 'Adding...', false);
                },
                success: function() {
                    accessoriesComponent.setCallToActionComponents($elementInstances, false, 'Remove', true);
                    $elementInstances.attr('data-remove-accessory', '');
                    $elementInstances.attr('data-buy-accessory', null);
                    $element.attr('data-analytic', 'remove_from_cart');
                },
                error: function() {
                    accessoriesComponent.setCallToActionComponents($elementInstances, false, 'Add', true);
                    $elementInstances.attr('data-remove-accessory', '');
                    $elementInstances.attr('data-buy-accessory', null);
                    $element.attr('data-analytic', 'add_to_cart');
                },
                complete: function() {
                    accessoriesComponent.updateBasketSummary();
                    accessoriesComponent.updateFullBasketContent(activeSlideIndex);
                    basketCounter.init();
                },
                dataType: 'json'
            });
        },
        setCallToActionComponents: function($element, disabled, ctaCopy, hideSpinner) {
            setTimeout(function() {
                disabled ? $element.attr('disabled', true) : $element.removeAttr('disabled');
            }, (disabled ? 0 : 3000));

            $element.find(accessoriesComponent.selectors.ctaCopy).html(ctaCopy);
            $element.find(accessoriesComponent.selectors.spinner).toggleClass('hide', hideSpinner);
        },
        removeFromBasket: function(event) {
            event.preventDefault();
            var $element = $(event.currentTarget),
                elementDealId = $element.data('dealId'),
                elementGiftCode = $element.data('giftCode'),
                elementParentId = $element.data('parentId'),
                $elementInstances = $('[data-remove-accessory][data-deal-id="' + elementDealId + '"][data-parent-id="' + elementParentId + '"]'),
                activeSlideIndex = $element.closest('.swiper-wrapper').children('.swiper-slide-active').prevAll().length;
            $element.toggleClass('btn-gray-shade-2', false);
            $element.toggleClass('btn-erminto', true);
            $.ajax({
                type: 'POST',
                url: '/beta/ajax/remove-from-basket',
                data: {
                    'dealId': elementDealId,
                    'giftCode': elementGiftCode,
                    'itemType': 'deal',
                    'parentId': elementParentId
                },
                beforeSend: function() {
                    accessoriesComponent.setCallToActionComponents($elementInstances, true, 'Removing...', false);
                },
                success: function() {
                    accessoriesComponent.setCallToActionComponents($elementInstances, false, 'Add', true);
                    $elementInstances.attr('data-remove-accessory', null);
                    $elementInstances.attr('data-buy-accessory', '');
                    $element.attr('data-analytic', 'add_to_cart');
                },
                error: function() {
                    accessoriesComponent.setCallToActionComponents($elementInstances, false, 'Add', true);
                    $elementInstances.attr('data-remove-accessory', null);
                    $elementInstances.attr('data-buy-accessory', '');
                    $element.attr('data-analytic', 'remove_from_cart');
                },
                complete: function() {
                    accessoriesComponent.updateBasketSummary();
                    accessoriesComponent.updateFullBasketContent(activeSlideIndex);
                    basketCounter.init();
                },
                dataType: 'json'
            });
        },
        updateBasketSummary: function() {
            $.ajax({
                type: 'POST',
                url: '/beta/ajax/fetch-basket-summary',
                data: {
                    'code': $('div[data-basket-summary-small]').data('code')
                },
                success: function(response) {
                    $('div[data-basket-summary-small]').replaceWith(response);
                    // Update price on sticky mobile view
                    const parser = new DOMParser();
                    const newSummary = parser.parseFromString(response, 'text/html');
                    const newPayTodayPriceEl = newSummary.querySelector('[data-total-today-price]');
                    const newPayMonthlyPriceEl = newSummary.querySelector('[data-total-monthly-price]');
                    if (!newPayTodayPriceEl || !newPayMonthlyPriceEl) {
                        return;
                    }
                    $('.basket-summary-sticky [data-total-today-price]').text(newPayTodayPriceEl.innerText);
                    $('.basket-summary-sticky [data-total-monthly-price]').text(newPayMonthlyPriceEl.innerText);
                },
                dataType: 'html'
            });
        },
        updateFullBasketContent: function(activeSlideIndex) {
            $.ajax({
                type: 'POST',
                url: '/beta/ajax/fetch-basket-full',
                data: {
                    'code': $('div[data-basket-summary-full]').data('code')
                },
                success: function(response) {
                    $('div[data-basket-summary-full]').replaceWith(response);
                },
                complete: function() {
                    if (typeof activeSlideIndex !== 'undefined') {
                        initAccessorySwiper(activeSlideIndex);
                    }
                },
                dataType: 'html'
            });
        },
    };

    function initAccessorySwiper(activeSlideIndex = 0) {
        document.querySelectorAll('.accessory-swiper').forEach(function(el) {
            const accessorySwiper = new Swiper(el, {
                freeMode: false,
                autoplay: false,
                speed: 750,
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 15,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: el.closest('.basket-item-upsells').querySelector('[data-accessory-next]'),
                    prevEl: el.closest('.basket-item-upsells').querySelector('[data-accessory-prev]')
                },
                pagination: {
                    el: el.parentElement.querySelector('.swiper-pagination'),
                    type: 'bullets'
                },
                on: {
                    init: function() {
                        updateAccessoryDataLayer();
                    },
                    slideChangeTransitionEnd: function() {
                        updateAccessoryDataLayer();
                    }
                }
            });
            accessorySwiper.slideTo(activeSlideIndex, 0, false);
        });
    }
    window.trackedAccessoryLists = window.trackedAccessoryLists || {};

    function updateAccessoryDataLayer() {
        $('.basket-item-upsells').each(function() {
            //  below code is to get the parent product family name
            var parentVoucher = $(this).find('.accessory-add-to-basket').data('parent-id');
            var productParentFamily = $('.basket-item[data-public-id="' + parentVoucher + '"]').attr('data-product-family').replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

            dataLayer.push(
                {
                    'ecommerce': null
                }
            );
            var itemArr = [];
            // $(this).find('.basket-accessory-upsell').each(function() {
            var swiperElement = $(this).find('.accessory-swiper')[0];
            if (!swiperElement || !swiperElement.swiper) {
                return;
            }
            const swiperInstance = swiperElement.swiper;
            const containerRect = swiperElement.getBoundingClientRect();
            swiperInstance.slides.forEach(function(slide) {
                const slideRect = slide.getBoundingClientRect();
                const isFullyVisible =
                    slideRect.left >= containerRect.left &&
                    slideRect.right <= containerRect.right;
                if (!isFullyVisible) {
                    return;
                }
                var accButton = $(slide).find('.accessory-add-to-basket');
                if (!accButton.length) {
                    return;
                }
                var thisPlan = {};
                // var accButton = $(this).find('.accessory-add-to-basket');
                thisPlan['item_id'] = accButton.data('product-code');
                thisPlan['item_name'] = 'Accessories: ' + accButton.data('product-name');
                thisPlan['item_category'] = 'ACC';
                thisPlan['item_category2'] = '';
                thisPlan['item_category3'] = '';
                thisPlan['item_category4'] = '';
                thisPlan['item_category5'] = '';
                thisPlan['item_varient'] = '';
                thisPlan['product_deal_id'] = String(accButton.data('deal-id'));
                thisPlan['product_data_variation'] = '';
                thisPlan['product_third_party_code'] = accButton.data('thirdparty-code');
                thisPlan['product_tariff_code'] = accButton.data('tariffcode');
                thisPlan['product_contract_length'] = '';
                thisPlan['product_texts_allowance'] = '';
                thisPlan['product_up_front_cost'] = String(accButton.data('price'));
                thisPlan['5g_enabled'] = '';
                thisPlan['e_sim_enabled'] = '';
                thisPlan['product_model'] = 'Accessories';
                thisPlan['deal_tag'] = '';
                thisPlan['product_card_ribbon'] = '';
                thisPlan['product_promotion'] = '';
                thisPlan['refurbished'] = '';
                thisPlan['item_brand'] = accButton.data('brand');
                thisPlan.quantity = 1;
                thisPlan.index = accButton.data('index');
                thisPlan.price = Number(accButton.data('price'));

                itemArr.push(thisPlan);
            });

            if (itemArr.length > 0) {
                var trackingKey =
                    'basket_accessories_carousel_' +
                    productParentFamily +
                    '_' +
                    parentVoucher;

                if (window.trackedAccessoryLists[trackingKey]) {
                    return;
                }

                window.trackedAccessoryLists[trackingKey] = true;

                dataLayer.push({
                    'event': 'view_item_list',
                    'ecommerce': {
                        'item_list_name': 'basket_accessories_carousel_' + productParentFamily,
                        'items': itemArr
                    }
                });
            }
            // if (itemArr.length > 0) {
            //     dataLayer.push({
            //         'event': 'view_item_list',
            //         'ecommerce': {
            //             'item_list_name': 'basket_accessories_carousel_' + productParentFamily,
            //             'items': itemArr
            //         }
            //     });
            // }
        });
    }
    accessoriesComponent.init();

    initAccessorySwiper();
})($);
